<template>
	<div id="app">
		<!-- 3.使用组件 -->
		<roheader></roheader>
		<!-- <testprops title="hellsksksksksks" color='red'></testprops>
		中间内容哦耶 -->
		<!-- 内容 -->
		<div class="ro-home-content-register">
			<div class="ro-home-content-box-register">
				<div
					style="width: 100%;float: right;background-color: white;border-radius: 5px;padding:40px 0px;box-shadow:0px 0px 20px #8a8a8a;">
					<span style="border-bottom:3px solid #07ccec;font-weight: 800;">忘记密码</span>
					<div class="form-group ro-register-input-box" style="margin-top: 50px;">
						<span style="float: left;width: 20%;">手机号</span>
						<input type="text" v-model='phone' class="form-control style2 ro-register-input"
							placeholder="请输入手机号码" style="" />
					</div><div class="form-group ro-register-input-box" >
						<span style="float: left;width: 20%;">email</span>
						<input type="text" v-model='email' class="form-control style2 ro-register-input"
							placeholder="请输入email" style="" />
					</div>
					<div class="form-group ro-register-input-box">
						<span style="float: left;width: 20%;">登陆密码</span>
						<input v-model='password' type="password" class="form-control style2 ro-register-input"
							placeholder="请设置登陆密码" style="" />
					</div>
					<div class="form-group ro-register-input-box">
						<span style="float: left;width: 20%;">确认密码</span>
						<input v-model='confirm_password' type="password" class="form-control style2 ro-register-input"
							placeholder="确认密码" style="" />
					</div>
					<div class="form-group ro-register-input-box">
						<span style="float: left;width: 20%;">验证</span>
						<input v-model='kapkey' type="text" style="position: relative;" required
							class="form-control style2 ro-register-input" placeholder="请输入验证码" />

						<button :disabled="isCounting" type="submit" class="vs-btn style2"
							style="position: absolute;top:0;right:0;z-index:999;width: 25%;border-radius: 8px;height:35px;line-height: 30px;padding:0;margin:7px;font-size: 12px;"
							@click="send_message">{{ buttonText }}</button>
					</div>
					<div style="overflow: hidden;margin:15px auto;">
						<a @click="change_password()" style="font-size: 12px;">
							<button type="submit" class="vs-btn style2"
								style="border-radius: 10px;height:50px;padding:0 80px;">重置</button>
						</a>

					</div>
				</div>
			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>
</template>
<script>
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";

	import testprops from "./components/test_props.vue";
	import {
		fetchPost
	} from "@/utils/request"
	export default {
		name: "App",
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			testprops,
		},
		data() {
			return {
				'phone': '',
				'password': '',
				'confirm_password': '',
				'kapkey': '',
				'isCounting': false,
				'countdown': 60,
				'countdownTimer': null,
				'message_type':'sms',
				'email':''

			}
		},
		computed: {
			buttonText() {
				return this.isCounting ? `${this.countdown}秒后重试` : '点击发送'
			},
			passwordsMatch() {
				return this.password === this.confirm_password
			}

		},
		mounted() {
			this.get_home_setting()

		},


		methods: {
			get_home_setting() {
				var self = this
				fetchPost('/ro/tec_search/settings/website/v1').then(response => {
					console.log(response.data)
					self.cscy_description = response.data.list.intro_tech
					self.cscy_url = response.data.list.tech_img

					self.kjcy_description = response.data.list.intro_reference
					self.kjcy_url = response.data.list.reference_img
					self.message_type = response.data.message_type

					self.sci_description = response.data.list.intro_sci
					self.sci_url = response.data.list.sci_img
					self.notice_url = response.data.list.notice_img
					self.notice = response.data.list.notice_list
					if (response.data.list.notice_list.length > 3) {
						self.show_find_more = true
					}
					self.term = response.data.list.term
				})
			},

			startCountdown() {
				this.isCounting = true
				this.countdownTimer = setInterval(() => {
					if (this.countdown > 0) {
						this.countdown--
					} else {
						clearInterval(this.countdownTimer)
						this.isCounting = false
						this.countdown = 60
					}
				}, 1000)
			},
			send_message() {
				var data = {
					'phone': this.phone,
					'email': this.email,
					'sms_type': 'verification',
					'page_type':'forget',
					'platform':'eshop'
				}
				var self = this
				if(this.message_type=='sms'){
					this.$alert('请从手机【' + this.phone + '】接收验证码。', '提示', {
						confirmButtonText: '确定',
						callback: action => {
							// this.$message({
							//   type: 'info',
							//   message: ``
							// });
						}
					});
					fetchPost('/ro/connector/aliyun/send_message/v1', data).then(response => {
						// debugger

						if (response.data == 'success') {
							self.$message({
								type: 'success',
								message: '发送成功,请注意查收短信'
							});
							this.startCountdown()
						} else {
							this.$message.error('发送失败，' + response.data);
						}
					})
				}
				else{
					this.$alert('请从邮箱【' + this.email + '】接收验证码。', '提示', {
						confirmButtonText: '确定',
						callback: action => {
							// this.$message({
							//   type: 'info',
							//   message: ``
							// });
						}
					});
					fetchPost('/ro/connector/email/send_message/v1', data).then(response => {
						// debugger
						if (response.data == 'success') {
							self.$message({
								type: 'success',
								message: '发送成功,请注意查收邮箱'
							});
							this.startCountdown()
						} else {
							this.$message.error('发送失败，' + response.data);
						}
					})
				}
				// this.startCountdown()

			},

			beforeDestroy() {
				clearInterval(this.countdownTimer)
			},
			change_password() {
				debugger
				var data = {
					'mobile': this.phone,
					'password': this.password,
					'kapkey':this.kapkey
				}
				if(this.kapkey=='' || this.phone=='' || this.password=='' || this.confirm_password==''){
					this.$message.error('请输入完整信息')
					return 
				}
				if (this.passwordsMatch) {					
					fetchPost('/ro/web_eshop/user/change_password/v1', data).then(response => {
						if (response.data.result == 'fail') {
							this.$message.error(response.data.reason)
						} else {
							this.$router.push("/pages/login")
						}
					})
				}  else {
					this.$message.error('两次密码不一致，请重新输入')
				}				
			},
		}

	};
</script>
<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	.ro-home-content-register {
		width: 100%;
		background: #F0F0F0;
		overflow: auto;
		padding: 150px 0;
		background-image: url(../assets/img/bg/bg-7.jpg);
		background-repeat: no-repeat;
		background-position: 50%;
		background-size: cover;
	}

	.ro-home-content-box-register {
		width: 940px;
		margin: auto;
		padding: 40px 0;
	}

	.vs-btn.style3:before,
	.vs-btn.style2:before {
		position: unset;
	}

	.ro-register-input-box {
		width: 50%;
		overflow: hidden;
		line-height: 50px;
		margin: auto;
	}

	.ro-register-input-box span {
		font-weight: 800;
	}

	.ro-register-input {
		border-radius: 10px !important;
		height: 50px !important;
		margin-bottom: 15px;
		width: 80%;
		float: left;
	}
</style>
